import { render, staticRenderFns } from "./EditName.vue?vue&type=template&id=8a6268f8&scoped=true&"
import script from "./EditName.vue?vue&type=script&lang=js&"
export * from "./EditName.vue?vue&type=script&lang=js&"
import style0 from "./EditName.vue?vue&type=style&index=0&id=8a6268f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6268f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a6268f8')) {
      api.createRecord('8a6268f8', component.options)
    } else {
      api.reload('8a6268f8', component.options)
    }
    module.hot.accept("./EditName.vue?vue&type=template&id=8a6268f8&scoped=true&", function () {
      api.rerender('8a6268f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/components/EditName.vue"
export default component.exports